export * from './localStorage';
export * from './sessionStorage';
export * from './webStorage';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-webstorage/dist/decorators/index.js
// module id = 1049
// module chunks = 3